import React from "react";
import ReactDOM from "react-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faChevronLeft,
  faSpinner,
  faExclamationCircle,
  faSave,
  faGlobe,
  faFileImport,
  faFileExport,
  faSearch,
  faTimesCircle,
  faChevronRight,
  faChevronDown
} from "@fortawesome/free-solid-svg-icons";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";

library.add(
  fab,
  faChevronLeft,
  faSpinner,
  faExclamationCircle,
  faSave,
  faGlobe,
  faFileImport,
  faFileExport,
  faSearch,
  faTimesCircle,
  faChevronRight,
  faChevronDown
);

/* eslint-disable-next-line */
ReactDOM.render(<App />, document.getElementById("app"));
